import { EmailAutomationTimeframes, EmailAutomationTriggers } from '../../../constants/emailAutomations';

export const buildDefaultTemplatesForStep = (trigger, timeframeType, timeframeValue) => {
  switch (trigger) {
    case EmailAutomationTriggers.PolicyExpiration:
      return [buildDefaultTemplatesForPolicyExpiration(timeframeType, timeframeValue)];
    default:
      throw new Error(`Invalid trigger: ${trigger}`);
  }
};

const buildDefaultTemplatesForPolicyExpiration = (timeframeType, timeframeValue) => {
  const subjectHtml = '{{cert_holder_company_name}} is Requesting Your Insurance';

  let variableContent = '';

  switch (timeframeType) {
    case EmailAutomationTimeframes.DaysBefore:
      variableContent = `expire in ${timeframeValue} days`;
      break;
    case EmailAutomationTimeframes.DaysAfter:
      variableContent = `have expired ${timeframeValue} days ago`;
      break;
    case EmailAutomationTimeframes.OnDayOf:
      variableContent = 'expire today.';
      break;
    default:
      throw new Error(`Invalid timeframe type: ${timeframeType}`);
  }

  return ({
    templateInfo: {
      subjectHtml,
      html: '<p>Dear {{insured_company_name}},</p>'
          + '<br />'
          + '<p>{{cert_holder_company_name}} is requesting proof of insurance for {{project_name}}.</p>'
          + '<br />'
          + '<p>The following policies are indicated to {{automation_time_frame_verb}}:</p>'
          + '<p>{{{automation_policy_list}}}</p>'
          + '<br />'
          + '<p>The following documents are indicated to {{automation_time_frame_verb}}:</p>'
          + '<p>{{{automation_document_list}}}</p>'
          + '<br />'
          + '<p>We have automated our insurance certificate tracking using PINS Advantage.'
          + 'Your agent will need to provide us with the insurance certificate and any associated documentation.</p>'
          + '<br />'
          + '<p><strong>Please forward this email to whomever is handling your insurance.</strong></p>'
          + '<br />'
          + '<p>Click the button below to submit the insurance certificate for {{insured_company_name}}:</p>'
          + '<br />'
          + '<p>{{{agent_portal_button}}}</p>'
    },
    templateName: 'PINS - Email Expiration Template',
    templateType: 'main_content',
    templateId: null,
    companyId: null,
    departmentId: null,
    userId: null
  });
};
